document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    // Handle product color button click
    if (event.target.classList.contains('product-color-btn')) {
      handleProductColorButtonClick(event);
    }
    // Handle size option (swatch) click
    if (event.target.classList.contains('swatch')) {
      handleSwatchClick(event);
    }
  });

  const gridItems = document.querySelectorAll('.grid__item');
  gridItems.forEach(gridItem => {
    const sizeBtnDiv = gridItem.querySelector('.size-btn');
    if (!sizeBtnDiv) {
      updateAddToCartButton(null, gridItem);
    }
  });

  setupCustomValidation(document);

  setupSlideCartIntegration();
});

// Define the custom validation setup function
function setupCustomValidation(context) {
  const sizeInputs = context.querySelectorAll('input[name="size"]:not(.validation-setup)');

  sizeInputs.forEach(input => {
    input.classList.add('validation-setup'); // Mark the input as set up
    input.addEventListener('invalid', handleInvalidEvent);
    input.addEventListener('change', handleChangeEvent);
  });
}

function reapplyValidation(sizeBtnDiv) {
  const sizeInputs = sizeBtnDiv.querySelectorAll('input[name="size"]');
  sizeInputs.forEach(input => {
    input.addEventListener('invalid', handleInvalidEvent);
    input.addEventListener('change', handleChangeEvent);
  });
}

function revalidateForm(sizeBtnDiv) {
  const form = sizeBtnDiv.closest('form');
  if (form) {
    form.reportValidity();
  }
}

function handleInvalidEvent(event) {
  event.target.setCustomValidity('נא לבחור מידה'); // Always set the custom message
}

function handleChangeEvent(event) {
  document.querySelectorAll('input[name="size"]').forEach(radio => {
    radio.setCustomValidity(''); // Clear custom validity for all size radio buttons
  });
  event.target.form.reportValidity(); // Trigger a re-validation check
}

function handleProductColorButtonClick(event) {
  var productHandle = event.target.getAttribute('selected-product-handle');
  const MainParentCard = event.target.closest('.grid-product__content');
  const addToCartButton = MainParentCard.querySelector('.custom-button-add');
  const ImageParentCard = event.target.closest('.grid-product__link');

  if (MainParentCard) {
    var sizeBtnDiv = MainParentCard.querySelector('.size-btn');
    if (sizeBtnDiv) {
      checkProductAvailability(productHandle, sizeBtnDiv, MainParentCard, ImageParentCard);

      // Reset the checked state of size radio buttons
      const sizeRadioButtons = sizeBtnDiv.querySelectorAll('input[type="radio"][name="size"]');
      sizeRadioButtons.forEach(radio => {
        radio.checked = false;
      });
    }

    // New code to handle the selected class for color buttons
    const colorButtonsParent = event.target.closest('.product-color-picker-wrapper');
    if (colorButtonsParent) {
      // Remove 'selected' class from all color buttons
      colorButtonsParent.querySelectorAll('.product-color-btn').forEach(btn => {
        btn.classList.remove('selected');
      });

      // Add 'selected' class to the clicked button
      if (event.target.classList.contains('product-color-btn')) {
        event.target.classList.add('selected');
      }
    }
  }
}

function handleSwatchClick(event) {
  const parentCard = event.target.closest('.grid-product__content');
  if (parentCard) {
    const addToCartButton = parentCard.querySelector('.custom-button-add');
    const hiddenInput = parentCard.querySelector('.swatch-hidden');
    const priceDisplay = parentCard.querySelector('.price-product');

    const wishlistButton = parentCard.querySelector('.add-to-wishlist-btn');
    const clickOverlay = parentCard.querySelector('.click-overlay');

    if (clickOverlay) {
      clickOverlay.style.display = 'none'; // Hide the overlay when the button is "enabled"
    }

    if (addToCartButton) {
      addToCartButton.disabled = false;
    }

    if (hiddenInput && event.target.id.startsWith('swatch-')) {
      hiddenInput.value = event.target.id.replace('swatch-', '');
      let variantId = event.target.id.replace('swatch-', '');

      if (wishlistButton) wishlistButton.setAttribute('data-variant-id', variantId);

      // Update the price display
      if (priceDisplay) {
        var selectedVariantId = hiddenInput.value;
        var variantRadio = document.getElementById(event.target.id);
        var variantPrice = variantRadio.getAttribute('data-price');
        priceDisplay.textContent = variantPrice;
      }
    }
  }
}

function updateFeaturedMediaUrl(product, parentCard) {
  // Find the closest product-card-link element
  const productCardLink = parentCard.closest('product-card-link');
  if (!productCardLink) return;

  // Use the first image or fallback
  const newImageUrl = product.images[0] || '';

  // Update the attribute
  productCardLink.setAttribute('data-featured-media-url', newImageUrl);
}

function updateProductLinksHref(parentCard, productHandle) {
  var commonParent = parentCard.closest('.grid-product__content');

  var productLinks = commonParent.querySelectorAll('a.product-card__link');

  productLinks.forEach(function (link) {
    link.href = '/products/' + productHandle;
    console.log('Updated href for product link:', link.href);
  });
}

function updateMainImage(product, parentCard) {
  var commonParent = parentCard.closest('.grid-product__content');

  // Select all main slideshow images
  var slideshowImages = commonParent.querySelectorAll('.product-media__image');

  // Function to update image source and srcset
  function updateImageElement(imageElement, imageUrl) {
    if (imageElement && imageUrl) {
      imageElement.src = imageUrl;

      const sizes = ["180x", "360x", "540x", "720x", "900x", "1080x", "1296x", "1512x", "1728x", "1944x", "2160x", "2376x", "2592x", "2808x", "3024x"];
      let newSrcset = sizes.map(size => {
        let newUrl = imageUrl.split('?')[0];
        newUrl = newUrl.replace(/(\d+x)/, size);
        return `${newUrl} ${size}`;
      }).join(', ');

      imageElement.setAttribute('srcset', newSrcset);
    }
  }

  // Update slideshow images with corresponding product images
  slideshowImages.forEach((imageElement, index) => {
    const imageUrl = product.images[index] || product.images[0];
    updateImageElement(imageElement, imageUrl);
  });
}

function formatMoney(amount) {
  // Convert cents to Shekels and format to 2 decimal places
  var formattedAmount = (amount / 100).toFixed(2);
  // Return the formatted amount with the currency symbol ₪
  return `${formattedAmount} ₪`;
}

function updatePriceDisplay(product, parentCard) {
  var priceProductDiv = parentCard.querySelector('.price');
  var originalPriceSpan = parentCard.querySelector('.compare-at-price');

  if (priceProductDiv) {
    priceProductDiv.textContent = formatMoney(product.price_min);
  }

  if (product.compare_at_price_min > product.price_min) {
    if (originalPriceSpan) {
      originalPriceSpan.textContent = formatMoney(product.compare_at_price_min);
      originalPriceSpan.style.display = ''; // Show if it was previously hidden
    } else {
      const newOriginalPriceSpan = document.createElement('span');
      newOriginalPriceSpan.classList.add('grid-product__price--original');
      newOriginalPriceSpan.textContent = formatMoney(product.compare_at_price_min);
      priceProductDiv.parentNode.insertBefore(newOriginalPriceSpan, priceProductDiv.nextSibling);
    }
  } else {
    if (originalPriceSpan) {
      originalPriceSpan.style.display = 'none';
    }
  }
}

function checkProductAvailability(productHandle, sizeBtnDiv, parentCard, ImageParentCard) {
  var url = '/products/' + productHandle + '.js';
  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Product not found');
      }
      return response.json();
    })
    .then(product => {
      // Find the first available variant and update the hidden input
      const firstAvailableVariant = product.variants.find(variant => variant.available);
      const wishlistButton = parentCard.querySelector('.add-to-wishlist-btn');

      const hiddenInput = parentCard.querySelector('.swatch-hidden');

      if (firstAvailableVariant && hiddenInput) {
        hiddenInput.value = firstAvailableVariant.id;

        if (wishlistButton) wishlistButton.setAttribute('data-variant-id', `${firstAvailableVariant.id}`);
        if (wishlistButton) wishlistButton.setAttribute('data-product-id', `${product.id}`);
        if (wishlistButton) wishlistButton.setAttribute('data-handle', `${product.handle}`);
      } else {
        hiddenInput.value = '0';
      }
      updateProductLinksHref(parentCard, productHandle);
      updateSizeOptions(product, sizeBtnDiv, parentCard);

      updateAddToCartButton(product, parentCard);
      updateMainImage(product, parentCard);
      updateFeaturedMediaUrl(product, parentCard);
      updatePriceDisplay(product, parentCard);
    })
    .catch(error => {
      console.error('Error fetching product data:', error);

      // Disable the color button related to this product
      if (parentCard) {
        const colorButton = parentCard.querySelector('.product-color-btn[selected-product-handle="' + productHandle + '"]');
        if (colorButton) {
          colorButton.disabled = true;
          colorButton.classList.add('disabled'); // Assuming you have a 'disabled' class
        }
      }
    });
}

function updateAddToCartButton(product, parentCard) {
  const addToCartButton = parentCard.querySelector('.custom-button-add');
  if (!addToCartButton) return;

  if (product) {
    console.log('Product:', product);
    const firstAvailableVariant = product.variants.find(variant => variant.available);
    console.log('First available Variant:', firstAvailableVariant);

    if (firstAvailableVariant) {
      addToCartButton.classList.remove('disabled'); // Optionally, remove the 'disabled' class if you're using it for styling
      addToCartButton.disabled = false; // Enable the button by setting the disabled property to false
      addToCartButton.textContent = 'הוספה לסל';
    } else {
      addToCartButton.classList.add('disabled'); // Optionally, add the 'disabled' class for styling purposes
      addToCartButton.disabled = true; // Disable the button by setting the disabled property to true
      addToCartButton.textContent = 'אזל המלאי';
    }
  } else {
    addToCartButton.classList.add('disabled'); // Optionally, add the 'disabled' class for styling
    addToCartButton.disabled = true; // Disable the button as there's no product
    addToCartButton.textContent = 'אזל המלאי';
  }
}

function updateSizeOptions(product, sizeBtnDiv, parentCard) {
  let sizeOptionsHTML = '';
  let sizeOptionIndex = -1;
  let existingSwatchHiddenValue = parentCard.querySelector('.swatch-hidden')?.value;

  product.options.forEach(function (option, index) {
    const optionNameLower = option.name.toLowerCase();
    if (optionNameLower === 'size' || optionNameLower === 'מידה' || optionNameLower === 'מידת נעליים') {
      sizeOptionIndex = index;
    }
  });

  if (sizeOptionIndex !== -1) {
    product.variants.forEach(function (variant) {
      const sizeValue = variant.options[sizeOptionIndex];
      const addToCartButton = parentCard.querySelector('.custom-button-add');
      // if (addToCartButton) {
      //   addToCartButton.disabled = false;
      // }
      const variantId = variant.id;
      const variantPrice = variant.price;

      let labelClass = variant.available ? 'variant-picker add_variant_to_cart' : 'variant-picker variant_no_instock';

      if (variant.available) {
        sizeOptionsHTML += `<div>
      <input type="radio" name="size" value="${sizeValue}" id="swatch-${variantId}" data-price="${formatMoney(variantPrice)}" class="swatch" required><label for="swatch-${variantId}" class="${labelClass}">${sizeValue}</label>
      </div>`;
      } else {
        sizeOptionsHTML += `<div>
      <input type="radio" name="size" value="${sizeValue}" id="swatch-${variantId}" data-price="${formatMoney(variantPrice)}" class="swatch" disabled><label for="swatch-${variantId}" class="${labelClass}">${sizeValue}</label>
      </div>`;
      }
    });
  }

  if (existingSwatchHiddenValue) {
    sizeOptionsHTML += `<input type="hidden" name="id" class="swatch-hidden" value="${existingSwatchHiddenValue}">`;
  }

  sizeBtnDiv.innerHTML = sizeOptionsHTML;
  // Reapply custom validation to new radio buttons
  reapplyValidation(sizeBtnDiv);

  const addToCartButton = parentCard.querySelector('.custom-button-add');
  //  if (addToCartButton) {
  //    addToCartButton.disabled = true;
  //  }
}

function setupSlideCartIntegration() {
  import('./events.js').then(({ CartUpdateEvent, ThemeEvents }) => {
    
    function triggerThemeCartUpdate(cart) {
      // If cart data is provided from callback, use it directly
      if (cart) {
        const cartUpdateEvent = new CartUpdateEvent(
          cart,
          'slide-cart-integration',
          {
            itemCount: cart.item_count,
            source: 'slide-cart'
          }
        );
        document.dispatchEvent(cartUpdateEvent);
      } else {
        // Otherwise fetch cart data
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartUpdateEvent = new CartUpdateEvent(
              cart,
              'slide-cart-integration',
              {
                itemCount: cart.item_count,
                source: 'slide-cart'
              }
            );
            document.dispatchEvent(cartUpdateEvent);
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });
      }
    }

    let isUpdatingFromTheme = false;

    function updateSlideCart() {
      if (window.SLIDECART_UPDATE) {
        isUpdatingFromTheme = true;
        window.SLIDECART_UPDATE();
      }
    }

    // Set up slide cart callbacks
    window.SLIDECART_LOADED = function(cart) {
      triggerThemeCartUpdate(cart);
    };

    window.SLIDECART_UPDATED = function(cart) {
      if (!isUpdatingFromTheme) {
        triggerThemeCartUpdate(cart);
      } else {
        isUpdatingFromTheme = false;
      }
    };

    // Listen to theme cart updates and sync with slide cart
    document.addEventListener(ThemeEvents.cartUpdate, (event) => {
      // Don't update slide cart if the update came from slide cart itself
      if (event.detail.data?.source === 'slide-cart') {
        return;
      }

      updateSlideCart();
    });
    
  }).catch(error => {
    console.error('Error importing theme events:', error);
  });
}